/**
 *
 * Details Service
 *
 */
import { FAILURE, LOADING, NAMESPACE, NOT_ASKED } from './constants';
import reducer from './reducer';
import sagas from './sagas';
import { selectStatus, selectResult, selectError } from './selectors';
import { updateWireRequest } from './actions';

export {
  FAILURE,
  LOADING,
  NAMESPACE,
  NOT_ASKED,
  reducer,
  sagas,
  selectStatus,
  selectResult,
  selectError,
  updateWireRequest,
};



// WEBPACK FOOTER //
// ./src/services/updateWire/index.js